import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-z112wl-0"
})(["padding:18px 24px 0;"]);
export var ContentBlock = styled.div.withConfig({
  displayName: "partials__ContentBlock",
  componentId: "sc-z112wl-1"
})(["margin-bottom:32px;text-align:center;"]);
export var TitleBlock = styled.div.withConfig({
  displayName: "partials__TitleBlock",
  componentId: "sc-z112wl-2"
})(["margin-top:0;margin-bottom:36px;text-align:center;"]);
export var FooterBlock = styled.div.withConfig({
  displayName: "partials__FooterBlock",
  componentId: "sc-z112wl-3"
})(["margin-top:24px;margin-bottom:36px;text-align:center;"]);